/* app/js/src/components/common/back-to-sceduler/back-to-scheduler.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.back-to-scheduler-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.back-to-scheduler-container .back {
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 10px;
  margin-right: 10px;
}
.back-to-scheduler-container .rounded-btn-prev {
  width: 28px;
  height: 28px;
  background-color: #f1f3f4;
  border-radius: 4px;
  text-align: center;
  padding-top: 7px;
  padding-right: 2px;
}
/*# sourceMappingURL=back-to-scheduler.component.css.map */
